// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPartnerCurrency } from '../../../utilities/selectors';
import { type ReferralDetails, type Currency } from '../../../utilities/types';
import { CommissionRateInfoDiv } from './CommissionRateInfoStyles';
import CommissionRateCard from './CommissionRateCard';
import { formatCurrency } from '../../../utilities/numberFormatting';

type Props = {
  referralDetails: ReferralDetails,
  partnerCurrency: Currency,
  flippers: {
    partner_referrals: boolean
  }
};

class CommissionRateInfo extends Component<Props> {
  render() {
    const { referralDetails } = this.props;
    return (
      <CommissionRateInfoDiv>
        <CommissionRateCard
          title="Your commission rates:"
          textOne={`Merchant Referrals: ${Number(
            referralDetails.commission_percentage_rate
          )}%`}
          textTwo={
            this.props.flippers.partner_referrals
              ? `Partner Referrals: ${Number(
                  referralDetails.partner_commission_percentage_rate
                )}%`
              : null
          }
        />
        <CommissionRateCard
          title="Default merchant fees:"
          textOne={`Amount per Transaction: ${formatCurrency(
            referralDetails.transaction_fee,
            this.props.partnerCurrency
          )}`}
          textTwo={`Percent per Transaction: ${referralDetails.transaction_fee_percent}%`}
        />
      </CommissionRateInfoDiv>
    );
  }
}

const mapStateToProps = state => ({
  referralDetails: state.global.referralDetails,
  partnerCurrency: getPartnerCurrency(state),
  flippers: state.global.flippers
});

export default connect(mapStateToProps)(CommissionRateInfo);
